// @flow

type MockEdgeAttributes = {|
  from: string,
  to: string,
|};

export type MockEdge = {|
  name: 'edge',
  attributes: MockEdgeAttributes,
  children: Array<any>,
|};

export const mockEdge = (
  attributes: MockEdgeAttributes,
  label: string,
  event?: string,
): MockEdge => {
  const children = [{name: 'Paragraph', children: [label]}];
  if (event) {
    children.push({
      name: 'Icon',
      attributes: {type: 'webhook', alt: event},
      children: [],
    });
  }
  return {
    name: 'edge',
    attributes,
    children,
  };
};
